module.exports = __webpack_public_path__ + "static/media/easy_difficulty.5c28564a.png";